module.exports = __webpack_public_path__ + "14f3ab6080f1b06a459c3f2ec76aa0bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/clarity-ui-icons.ttf
// module id = 1563
// module chunks = 0